export default __webpack_public_path__ + "static/chatgpt-607cedd78db2d30a0f84c018bd8de409.png";